import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Valkyrie, { viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

import CountryFlag from "../CountryFlag";

function OptionButton({ outboundRule, prefix, outboundDispatch, setActivePrefix, activePrefix }) {
  const phoneNumberList = useSelector((state) => state.domain.pbx.phoneNumbers);
  const inboundRouteStore = useSelector((state) => state.domain.inboundRoutes);

  const [processing, setProcessing] = useState(false);

  const outgoingNumberList = useMemo(
    () =>
      phoneNumberList?.map((phoneNumber) => ({
        did: phoneNumber.did,
        name: inboundRouteStore.list.find((inbound) => inbound.did === phoneNumber.did)?.name || "",
      })),
    [inboundRouteStore.list, phoneNumberList],
  );

  const caller = useMemo(
    () => outgoingNumberList.find((outgoingNumber) => outgoingNumber.did === prefix.callerId),
    [outgoingNumberList, prefix.callerId],
  );

  function deleteOption() {
    setProcessing(true);

    Promise.resolve(Api.deleteOutboundDestination(outboundRule, prefix))
      .then(() => {
        outboundDispatch({ type: "deletePrefix", prefix });

        if (activePrefix.id === prefix.id) {
          setActivePrefix(null);
        }
      })
      .finally(() => setProcessing(false));
  }

  return (
    <ListItem
      disablePadding
      key={prefix.input}
      secondaryAction={
        prefix.id && (
          <IconButton onClick={deleteOption}>
            <Valkyrie icon={processing ? viSpinnerThird : viTrashCan} spin={processing} />
          </IconButton>
        )
      }
    >
      <ListItemButton
        selected={activePrefix?.id === prefix.id}
        onClick={() => setActivePrefix(prefix)}
        id={`rule${prefix.id}`}
      >
        <ListItemIcon>
          <CountryFlag number={prefix.destinationPrefix} fontSize="1em" />
        </ListItemIcon>
        <ListItemText
          primary={prefix.destinationPrefix}
          secondary={
            <>
              {caller?.did}
              {caller?.name ? <span style={{ opacity: 0.6 }}>&nbsp;&middot; {caller.name}</span> : null}
            </>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}

OptionButton.propTypes = {
  outboundRule: PropTypes.object,
  prefix: PropTypes.object,
  setActivePrefix: PropTypes.func,
  activePrefix: PropTypes.object,
  outboundDispatch: PropTypes.func,
};

export default OptionButton;
